import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 *
 * Component for showing a summary of all form validation errors.
 *
 * @params see propTypes
 * @returns {JSX.Element}
 * @component
 */
const ValidationErrorSummary = ({ errors }) => {
  /**
   * React ref of the error unordered list.
   * @type {React.MutableRefObject<null>}
   */
  const errorsUl = useRef(null);

  /**
   * Focus on first error in summary instead of first input.
   * */
  useEffect(() => {
    errorsUl?.current?.querySelector('a')?.focus();
  });

  /**
   * Sets the input focus when the relevant error message is clicked.
   *
   * @param {object} event - The event object
   * @param {React.MutableRefObject} ref - A react ref
   */
  const setInputFocus = (event, elementId) => {

    event.preventDefault();

    const el = document.querySelector(`#${elementId}`);
    if (!el) {
      return;
    }

    el.scrollIntoView({
      'block': 'center'
    });

    if (elementId === 'g-recaptcha') {
      const iframeDoc = el.querySelector('iframe[title="reCAPTCHA"]');
      iframeDoc.focus();
      return;
    }

    el.focus();

  };
  return (
    <div className="l-section__content-wrapper mt-12 py-0 px-md-20">
      <div className="border border-rhubarb-triangle p-5">
        <h2 role="alert">
          There is a problem
        </h2>
        <ul
          className="d-flex flex-column p-0"
          ref={errorsUl}>
          {
            Object.entries(errors).map(([key, validationError], i) =>
              <li
                className={`d-flex mt-${i === 0 ? '5' : '2'}`}
                key={key}>
                <span>
                   -&nbsp;
                </span>

                <a
                  href={'#' + key}
                  className="fw-normal"
                  onClick={e => setInputFocus(e, key)}>
                  {validationError.message}
                </a>
              </li>
            )
          }
        </ul>
      </div>
    </div>
  );
};

ValidationErrorSummary.propTypes = {
  /**
   * A react hook form errors object containing all form validation errors.
   */
  errors: PropTypes.object.isRequired
};

export default ValidationErrorSummary;
